<template>
  <div>
    <popup-add-campaign ref="popupAddCampaign" />
    <popup-duplicate-master-campaign ref="popupDuplicate" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">HQ Campaigns</h3>
        <p class="mt-5">
          This is the list of marketing campaigns created by HQ. A HQ Campaign is created when it needs to be managed and sent for multiple
          venues.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="onClickCreateNew"
            type="relief"
            vslor="primary"
            v-if="hasPermission('vp.crm.campaigns.edit')"
            >Create campaign</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <div v-if="isLoading" class="flex flex-col justify-center items-center mt-12 pt-12">
      <span class="flex h-6 w-6 mb-5">
        <span class="animate-ping absolute inline-flex h-6 w-6 rounded-full bg-primary opacity-75"></span>
        <span class="relative inline-flex rounded-full h-6 w-6 bg-primary"></span>
      </span>
      <span> Loading</span>
    </div>

    <div v-if="!isLoading">
      <h5 class="mt-6">Filter by status</h5>
      <span class="text-grey font-bold">Number of campaigns matched by filter: {{ filteredMasterCampaigns.length }}</span>
      <vs-row vs-justify="flex-start" class="mt-4">
        <vs-button
          class="rounded-none rounded-l-lg w-48"
          :color="showDraft ? 'primary' : 'grey'"
          @click="showDraft = !showDraft"
          :icon="showDraft ? 'check' : ''"
        >
          Draft
        </vs-button>
        <vs-button
          class="rounded-none w-48"
          :color="showActive ? 'primary' : 'grey'"
          @click="showActive = !showActive"
          :icon="showActive ? 'check' : ''"
        >
          Active
        </vs-button>
        <vs-button
          class="rounded-none w-48"
          :color="showApproved ? 'primary' : 'grey'"
          @click="showApproved = !showApproved"
          :icon="showApproved ? 'check' : ''"
        >
          Approved
        </vs-button>
        <vs-button
          class="rounded-none w-48 rounded-r-lg"
          :color="showCompleted ? 'primary' : 'grey'"
          @click="showCompleted = !showCompleted"
          :icon="showCompleted ? 'check' : ''"
        >
          Completed
        </vs-button>
      </vs-row>
    </div>

    <!-- table -->
    <div class="data-list-container data-list-list-view" v-if="!isLoading">
      <!-- <h3>{{ activeVenue.name }}</h3> -->
      <vs-table
        ref="table"
        class="mt-8"
        maxItems="10"
        pagination
        search
        v-model="selected"
        :data="filteredMasterCampaigns"
        @selected="onClicked(selected.id)"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="title">Campaign name</vs-th>
          <vs-th sort-key="masterStatus">Status</vs-th>
          <vs-th sort-key="numVenues">Number of venues</vs-th>
          <vs-th sort-key="approvedByDate">VM fill out by</vs-th>
          <vs-th sort-key="firstSendDate">First send date</vs-th>
          <vs-th >Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.title }}
                </p>
              </vs-td>
              <vs-td>
                <vs-chip :color="masterStatusObject(tr.masterStatus).color">
                  <b>{{ masterStatusObject(tr.masterStatus).text }}</b>
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.numVenues }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ moment(tr.approvedByDate).format("DD-MM-yyyy") }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  <vs-chip
                    v-if="moment(tr.firstSendDate).isBefore() && tr.masterStatus != 'Completed' && tr.masterStatus != 'ApprovedForSending'"
                    color="danger"
                  >
                    {{ tr.firstSendDate | formatDate }}
                  </vs-chip>
                  <span v-else>
                    {{ tr.firstSendDate | formatDate }}
                  </span>
                </p>
              </vs-td>
              <vs-td>
                <vs-button
                  id="warning-button"
                  @click.native.stop="$refs.popupDuplicate.show(tr.id)"
                  v-if="hasPermission('vp.crm.campaigns.edit')"
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-copy">
                  
                </vs-button>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import PopupAddCampaign from "./Components/PopupAddCampaign.vue";
import PopupDuplicateMasterCampaign from "./Components/PopupDuplicateMasterCampaign.vue";

export default {
  components: {
    PopupAddCampaign,
    PopupDuplicateMasterCampaign
  },
  mixins: [campaignMixin],
  data() {
    return {
      moment,
      newMessageTitle: "",
      selected: [],
      isLoading: true,

      showDraft: false,
      showActive: true,
      showApproved: false,
      showCompleted: false
    };
  },
  methods: {
    calculateFirstSendDate(masterCampaign) {
      if (!masterCampaign.venueCampaignDates || masterCampaign.venueCampaignDates.length == 0) return "";

      const smsDates = masterCampaign.venueCampaignDates.map(venueCampaignDate => venueCampaignDate.sendSmsDate);
      const emailDates = masterCampaign.venueCampaignDates.map(venueCampaignDate => venueCampaignDate.sendEmailDate);

      return [...smsDates, ...emailDates].reduce((a, b) => (a < b ? a : b), Infinity);
    },
    async onClickCreateNew() {
      this.$refs.popupAddCampaign.show();
    },
    onClicked(id) {
      this.$router
        .push({
          name: "crm-campaign",
          params: {
            id
          }
        })
        .catch(e => {});
    }
  },
  computed: {
    ...mapGetters({
      masterCampaigns: "masterCampaigns/all"
    }),
    filteredMasterCampaigns() {
      let campaigns = this.masterCampaigns;
      if (!this.showDraft) {
        campaigns = campaigns.filter(campaign => campaign.masterStatus !== "Draft");
      }
      if (!this.showActive) {
        campaigns = campaigns.filter(campaign => campaign.masterStatus !== "Active");
      }
      if (!this.showApproved) {
        campaigns = campaigns.filter(campaign => campaign.masterStatus !== "ApprovedForSending");
      }
      if (!this.showCompleted) {
        campaigns = campaigns.filter(campaign => campaign.masterStatus !== "Completed");
      }

      // Map the campaigns to include firstSendDate and numVenues
      campaigns = campaigns.map(campaign => ({
        ...campaign,
        numVenues: campaign.venues.length,
        firstSendDate: this.calculateFirstSendDate(campaign)
      }));

      return campaigns;
    }
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch("masterCampaigns/getAll");
    this.isLoading = false;
  }
};
</script>

<style lang="scss">
</style>
